<template>
  <img
    :src="getImgUrl(this.model)"
    :alt="this.altText"
    :id="this.id ?? this.src"
    :class="this.class"
  />
</template>

<script>
import { brandCrest } from "../../constants/labels.config";
export default {
  name: "DefaultImage",
  props: ["model", "altText", "class", "id"],
  methods: {
    getImgUrl(model) {
      if (window.BRAND.toLowerCase() !== brandCrest.toLowerCase()) {
          return "/img/boats/PlaceholderImages/MasterCraft/view_boat_details.jpg";
      } else {
        if (
          model !== undefined ||
          model !== null ||
          model.toLowerCase() !== ""
        ) {
          if (model.toLowerCase().includes("caribbean lx"))
            return "/img/boats/PlaceholderImages/Crest/Caribbean LX.png";
          else if (model.toLowerCase().includes("caribbean platinum"))
            return "/img/boats/PlaceholderImages/Crest/Caribbean Platinum.png";
          else if (model.toLowerCase().includes("caribbean rs"))
            return "/img/boats/PlaceholderImages/Crest/Caribbean RS.png";
          else if (model.toLowerCase().includes("classic dlx"))
              return "/img/boats/PlaceholderImages/Crest/Classic DLX.png";
          else if (model.toLowerCase().includes("classic fish"))
              return "/img/boats/PlaceholderImages/Crest/Classic Fish.png";
          else if (model.toLowerCase().includes("classic lx"))
            return "/img/boats/PlaceholderImages/Crest/Classic LX.png";
          else if (model.toLowerCase().includes("classic platinum"))
            return "/img/boats/PlaceholderImages/Crest/Classic Platinum.png";
          else if (model.toLowerCase().includes("continental nx"))
            return "/img/boats/PlaceholderImages/Crest/Continental NX.png";
          else if (model.toLowerCase().includes("continental"))
            return "/img/boats/PlaceholderImages/Crest/Continental.png";
          else if (model.toLowerCase().includes("savannah"))
            return "/img/boats/PlaceholderImages/Crest/Savannah.png";
          else
            return "/img/boats/PlaceholderImages/Crest/Caribbean LX.png";
        } else {
          return "/img/boats/PlaceholderImages/Crest/Caribbean LX.png";
        }
      }
    },
  },
};
</script>